<script setup>

import { onMounted } from 'vue'
import QuestionGroupComponent from '@/components/CompiledPoll/QuestionGroupComponent.vue'

const props = defineProps(['handleAnswer', 'compiledPoll', 'question']);
const answerValue = defineModel('answerValue')
const answerNote = defineModel('answerNote')

onMounted(()=>{
  props.compiledPoll['answers'].forEach((el) => {
    if(el['note']) answerNote.value = el['note'];
    if (el['questionReference'] === props.question['reference']) {
      answerValue.value = el['value'];
    }
  });

  if (props.handleAnswer !== null){
    props.handleAnswer(props.question['reference'], answerValue.value, false);
  }
});

function selectValueF() {
  if (props.handleAnswer !== null) {
    props.handleAnswer(props.question['reference'], answerValue.value, false, answerNote.value);
  }
}

function checkQuestionGroupDependentQuestionCondition(childQuestionGroup) {
  let condition = childQuestionGroup['dependentQuestionCondition'];
  let found = false;
  if (condition && condition === answerValue.value) {
    found = true;
  }

  if (!found) {
    resetAnswersChildQuestionGroup(childQuestionGroup)
  }
  return found;
}

function resetAnswersChildQuestionGroup(childQuestionGroup) {
  let questions = childQuestionGroup['questions'];
  questions.forEach((question, ) => {
    props.handleAnswer(question['reference'], null, true);
    if (question['childQuestionGroups'] && question['childQuestionGroups'].length > 0) {
      question['childQuestionGroups'].forEach((group, ) => {
        resetAnswersChildQuestionGroup(group);
      })
    }
  })
}

</script>

<template>
  <div>
    <label :for="'selectQuestion'+question['id']" :class="'form-label'+ (question.required ? ' fw-bold ' : '')">{{ question.text }} {{ question.required ? '*' : '' }}</label>
    <div class="pe-2">
      <select @change="selectValueF" :disabled="compiledPoll['state'] === 'filled' || handleAnswer === null" class="form-select w-100" :required="question.required" :aria-label="question.text" :name="question['id']" :id="'selectQuestion'+question['id']" v-model="answerValue">
        <option :selected="answerValue === null" :value="null">Seleziona opzione</option>
        <option :selected="answerValue === selectValue.value" v-for="(selectValue) in question['additionalProperties']['select_values']" :key="selectValue.value" :value="selectValue.value">{{ selectValue.label }}</option>
      </select>
    </div>
    <small v-if="question.helper" class="form-text">{{ question.helper }}</small>

    <div v-for="childQuestionGroup in question['childQuestionGroups']" :key="childQuestionGroup['id']">
      <div class="mt-2" v-if="checkQuestionGroupDependentQuestionCondition(childQuestionGroup)">
        <question-group-component :compiled-poll="compiledPoll" :handle-answer="handleAnswer" :question-group="childQuestionGroup"></question-group-component>
      </div>
    </div>

    <div v-if="question.hasNote" class="pt-2">
      <div class="pe-2">
        <label :for="'noteQuestion'+question['id']" class="form-label">Note</label>
        <textarea @change="selectValueF"
                  class="form-control" rows="2" placeholder="Inserisci note"
                  :id="'noteQuestion'+question['id']"
                  v-model="answerNote"
                  :disabled="!(compiledPoll['state'] !== 'filled' && handleAnswer !== null)"></textarea>
      </div>
    </div>
  </div>
</template>
